import React from 'react'

const ShimmerUIBlog = () => {
  return (
    <div className='grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 place-items-center gap-y-10 mb-10 mt-4'>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
        <div className=' w-[220px] rounded-full h-[220px] border-2 shadow-xl'></div>
    </div>
  )
}

export default ShimmerUIBlog